import { render, staticRenderFns } from "./DataManageSection.vue?vue&type=template&id=a1ef1266&scoped=true&"
import script from "./DataManageSection.vue?vue&type=script&lang=js&"
export * from "./DataManageSection.vue?vue&type=script&lang=js&"
import style0 from "./DataManageSection.vue?vue&type=style&index=0&id=a1ef1266&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ef1266",
  null
  
)

export default component.exports